import { Typography } from '@andes/typography';

import { AppProvider } from '../../../../providers/AppProvider';
import EmptyPageIcon from '../../../../assets/images/EmptyPageIcon';
import {
  getServerSideProps,
  setPageSettings,
} from '../../../../server/hooks/error-404';

interface NotFoundProps {
  domain: string;
  env: string;
  translations: {
    title?: string;
    text?: string;
  };
}

const NotFound = ({ domain, translations, env }: NotFoundProps) => (
  <AppProvider envParam={env} trackingIdParam="">
    <section className="message-container">
      <EmptyPageIcon />
      <Typography
        className="primaryMessage"
        component="h1"
        type="title"
        size="xl"
        color="primary"
      >
        {translations.title}
      </Typography>
      <a href={`https://www.${domain}`}> {translations.text}</a>
    </section>
  </AppProvider>
);

export { getServerSideProps, setPageSettings };

export default NotFound;
